import { DownIconContainer, FloatingChevron } from "./style";

function DownIcon() {
  return (
    <DownIconContainer>
      <FloatingChevron />
    </DownIconContainer>
  );
}

export default DownIcon;
